var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "110px",
    height: "110px",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n                .cls-1 {\n                    fill: none;\n                    stroke: #000000;\n                    stroke-linecap: round;\n                    stroke-linejoin: round;\n                    stroke-width: 20px;\n                }\n            ")), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2",
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "E421, Back, buttons, multimedia, play, stop",
    id: "E421_Back_buttons_multimedia_play_stop"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 256,
    cy: 256,
    r: 246
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 352.26,
    x2: 170.43,
    y1: 256,
    y2: 256
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "223.91 202.52 170.44 256 223.91 309.48"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.6031c770426aee767ab2d06c86b380f8.svg";
export { ForwardRef as ReactComponent };